// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"bec44306","703":"0db94c7f"}[chunkId] + ".chunk.js";
};